<template>
  <div>
    <div class="row mt-3">
      <div class="col-12">
        <div class="d-flex align-items-center mb-2">
          <i class="fas fa-info-circle mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Descripción de Equipo
          </div>
        </div>
      </div>
    </div>
    <div class="row py-3">
      <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
        <div class="color-secondary-6 font-14 font-weight-normal mr-2">
          Estatus de Equipo:
        </div>
        <div class="color-black font-16 font-weight-normal">
          <custom-balloon
            :background-color="item.equipmentStatusColor"
            class="mt-2"
            :text="item.equipmentStatusName"
            dot
          />
        </div>
      </div>
      <div
        v-for="(property, index) in item.properties"
        :key="index"
        class="col-md-2 col-12 col-spacing mb-3 mb-lg-0"
      >
        <div class="color-secondary-6 font-14 font-weight-normal mr-2">
          {{ property.id }}
        </div>
        <div class="color-black font-16 font-weight-normal">
          {{ property.name | empty }}
        </div>
      </div>
      <div class="col-12 col-spacing mb-3 mb-lg-0 mt-5">
        <div class="color-secondary-6 font-14 font-weight-normal mr-2">
          Descripción:
        </div>
        <div class="color-black font-16 font-weight-normal">
          {{ item.description | empty }}
        </div>
      </div>
      <div class="col-12 col-spacing mb-3 mb-lg-0 mt-4">
        <div class="color-secondary-6 font-14 font-weight-normal mr-2">
          Datos de Ubicación / Dirección:
        </div>
        <div class="color-black font-16 font-weight-normal">
          {{ item.address | empty }}
        </div>
      </div>
      <div
        class="col-12 col-spacing mb-3 mb-lg-0 mt-4"
        v-if="item.accessories.length > 0"
      >
        <div class="color-secondary-6 font-14 font-weight-normal mr-2">
          Accesorio(s):
        </div>
      </div>
      <div class="col-12 px-4 mt-2 m-2">
        <div class="row">
          <div
            class="col-12 col-lg-3 pl-0 d-flex justify-content-between"
            v-for="(accessory, index) in item.accessories"
            :key="index"
          >
            <div class="bg-gray rounded p-2 mr-2 mb-2 w-100">
              <p class="font-16 font-weight-bold mb-0">
                {{ accessory.id }}
              </p>
              <p class="font-14">
                <span class="text-muted">
                  {{ accessory.name }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import documentService from '@/services/api/document.api.js';
import mixAlert from '@/mixins/alert.mixin';
import CustomBalloon from 'custom-balloon';
export default {
  name: 'RequestInfo',
  components: {
    CustomCallout,
    ActionButton,
    CustomBalloon,
  },
  mixins: [mixAlert],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasDocument() {
      return this.item.documentType && this.item.documentTitle;
    },
  },
  methods: {
    async downloadHandler() {
      await documentService
        .downloadFromServer(this.item.documentId)
        .catch(() => {
          this.ShowToast(
            'Error',
            'Hubo un error al descargar el documento',
            'error'
          );
        });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep div.custom-callout div.bg-secondary-3 {
  background: #f8f8f8 !important;
}
.w-100 {
  width: 100% !important;
}
</style>
